import { render, staticRenderFns } from "./AutoClassification.vue?vue&type=template&id=401df436&"
import script from "./AutoClassification.vue?vue&type=script&lang=js&"
export * from "./AutoClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports